import { sendContact } from '../../../../../../../../helpers/form.new/tasks/send.contact';
import { formDataToFb } from '../../../../../../../../store/adapters/formStore';
import { getStore } from '../../../../../../../../store/client';

export const onComplete = async () => {
    const { formData, fbPayload, userId } = getStore().getState().formStore;
    if (userId) {
        await sendContact(userId, formDataToFb(formData), fbPayload);
    }
};
